import { yupResolver } from "@hookform/resolvers/yup";
import Icon from "@mui/material/Icon";
import InputAdornment from "@mui/material/InputAdornment";
import { useState } from "@wordpress/element";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { TextField, Button } from "vino/core";
import * as yup from "yup";
import _ from "lodash";
import { submitRegister } from "store/auth/registerSlice";
/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
	firstName: yup.string().required("First name is required"),
	lastName: yup.string().required("Last name is required"),
	email: yup
		.string()
		.email("You must enter a valid email")
		.required("You must enter a email"),
	password: yup
		.string()
		.required("Please enter your password.")
		.min(8, "Password is too short - should be 8 chars minimum."),
	passwordConfirm: yup
		.string()
		.oneOf([yup.ref("password"), null], "Passwords must match"),
});

const defaultValues = {
	firstName: "",
	lastName: "",
	email: "",
	password: "",
	passwordConfirm: "",
};

function RegisterForm({ redirectUrl }) {
	const dispatch = useDispatch();
	const isSubmitting = useSelector(({ auth }) => auth.register.isSubmitting);
	const methods = useForm({
		mode: "onChange",
		defaultValues,
		resolver: yupResolver(schema),
	});
	const { handleSubmit } = methods;

	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	function onSubmit(model) {
		dispatch(submitRegister(model, redirectUrl));
	}

	return (
		<div className="w-full">
			<FormProvider {...methods}>
				<form
					noValidate
					className="flex flex-col justify-center w-full"
					onSubmit={handleSubmit(onSubmit)}
				>
					<div className="mb-16">
						<TextField
							name="firstName"
							className="mb-16"
							type="text"
							label="First name"
							variant="outlined"
							required
							fullWidth
						/>
					</div>

					<div className="mb-16">
						<TextField
							name="lastName"
							className="mb-16"
							type="text"
							label="Last name"
							variant="outlined"
							required
							fullWidth
						/>
					</div>
					<div className="mb-16">
						<TextField
							name="email"
							type="text"
							label="Email"
							required
							fullWidth
							variant="outlined"
						/>
					</div>
					<div className="mb-16">
						<TextField
							name="password"
							label="Password"
							type="password"
							variant="outlined"
							fullWidth
							required
							InputProps={{
								className: "pr-2",
								type: showPassword ? "text" : "password",
								endAdornment: (
									<InputAdornment position="end">
										<Icon
											onClick={() => setShowPassword(!showPassword)}
											className={clsx(
												"cursor-pointer text-20 fa-solid",
												showPassword ? "fa-eye" : "fa-eye-slash"
											)}
											color="action"
										/>
									</InputAdornment>
								),
							}}
						/>
					</div>
					<div>
						<TextField
							name="passwordConfirm"
							className="mb-16"
							type="password"
							label="Confirm Password"
							variant="outlined"
							required
							fullWidth
							InputProps={{
								className: "pr-2",
								type: showConfirmPassword ? "text" : "password",
								endAdornment: (
									<InputAdornment position="end">
										<Icon
											onClick={() =>
												setShowConfirmPassword(!showConfirmPassword)
											}
											className={clsx(
												"cursor-pointer text-20 fa-solid",
												showConfirmPassword ? "fa-eye" : "fa-eye-slash"
											)}
											color="action"
										/>
									</InputAdornment>
								),
							}}
						/>
					</div>
					<div className="flex justify-end">
						<Button
							isSubmitting={isSubmitting}
							type="submit"
							className="w-full mx-auto mt-16"
							value="legacy"
						>
							Create account
						</Button>
					</div>
				</form>
			</FormProvider>
		</div>
	);
}

export default RegisterForm;
